import React, { useState } from 'react';
import { HiddenPasswordModal } from './';
import AuthenticationProtection from '../ProtectedPages/AuthenticationProtection';
import { matchPath, useLocation } from 'react-router-dom';

const ProtectionWrapper = ({ eventId, eurekaOnly, attendingOnly, hiddenPassword, children }) => {
    const location = useLocation();
    const [_, setIsPasswordEntered] = useState(false);
    const enteredHiddenPassword = localStorage.getItem(`${eventId}_enteredHiddenPassword`);
    const hasProtection = eurekaOnly || attendingOnly;
    const matcherForKiosk = matchPath(location.pathname, {
        path: '/kiosk/:eventName',
        strict: false,
    });

    if (matcherForKiosk) {
        return children;
    }

    if (hiddenPassword && (!enteredHiddenPassword || enteredHiddenPassword !== hiddenPassword)) {
        return (
            <HiddenPasswordModal
                password={hiddenPassword}
                eventId={eventId}
                onDone={() => setIsPasswordEntered(true)}
            />
        );
    }
    if (hasProtection) {
        return (
            <AuthenticationProtection routeProtection fullScreen>
                {children}
            </AuthenticationProtection>
        );
    }

    return children;
};

export default ProtectionWrapper;
